import {
  FINANCIAL_TERMS_FETCH,
  LINKS_CREATE_LINK,
  LINKS_FETCH,
  LINKS_FETCH_LINK,
  LINKS_RESET_DATA,
  LINKS_SET_DATA,
  LINKS_UPDATE_LINK,
} from 'modules/Referral/ReferralLinks/types'

export const actionFetchLinks = (props) => ({
  type: LINKS_FETCH,
  payload: props,
})

export const actionUpdateLink = (props) => ({
  type: LINKS_UPDATE_LINK,
  payload: props,
})

export const actionCreateLink = (props) => ({
  type: LINKS_CREATE_LINK,
  payload: props,
})

export const actionFetchTerms = (props) => ({
  type: FINANCIAL_TERMS_FETCH,
  payload: props,
})

export const actionFetchLink = (props) => ({
  type: LINKS_FETCH_LINK,
  payload: props,
})

export const actionSetLinks = (props) => ({
  type: LINKS_SET_DATA,
  payload: props,
})

export const actionResetLinks = () => ({
  type: LINKS_RESET_DATA,
})
